import { Box, Typography } from '@mui/material';
import React from 'react';

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
};

export const ManageShopSection: React.FC<Props> = ({ title, children }) => (
  <Box
    sx={{
      mb: 2,
      p: 3,
      borderRadius: 2,
      bgcolor: 'background.default',
      border: 1,
      borderColor: 'divider',
    }}
  >
    {title && (
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
        {title}
      </Typography>
    )}
    {children}
  </Box>
);
